export default "__VITE_ASSET__Da4njNSF__"